













































import Vue from "vue";

// Vue components
import EditInstallationsBranchDialog from "./EditInstallationsBranchDialog.vue";

export default Vue.extend({
    components: {
        EditInstallationsBranchDialog,
    },
    data() {
        return {
            isEditMode: false,
            localBranch: null,
        };
    },
    props: {
        branch: { required: true, type: Object },
    },
    computed: {
        isLocalBranchNameNullOrWhitespaces() {
            return this.localBranch.name == null || this.localBranch.name.match(/^ *$/) !== null;
        },
    },
    methods: {
        onDelete() {
            this.$emit("delete", this.localBranch.id);
        },

        onSave() {
            this.$emit("edit", this.localBranch);
            this.isEditMode = !this.isEditMode;
        },

        toggleEditMode() {
            this.isEditMode = !this.isEditMode;
            this.localBranch = Object.assign({}, this.branch);
        },
    },
    mounted() {
        this.localBranch = Object.assign({}, this.branch);
    },
});
